export default {
	mutations: {
		RESET({state, commit}, payload) {
			payload = payload || {};
			payload.exclude = payload.exclude || [];
			for (module in this._modules.root._children) {
				if (payload.exclude.indexOf(module) > -1) {
					continue;
				}
				this.commit(module + "/RESET");
			}
		},
	},
};
